export default () => ({
  placebo(URL, width = 0, height = 0, suffix = 'jpeg') {
    suffix = 'webp';
    if (!URL || !(typeof URL === 'string' || URL instanceof String)) {
      return '';
    }
    if (!(URL.startsWith('https:') || URL.startsWith('http:'))) {
      URL = 'https:' + URL;
    }

    return URL.toString()
      .replace('{width}', width.toString())
      .replace('{height}', height.toString())
      .replace('{suffix}', suffix);
  },
  srcSet(url, widthArray = []) {
    let str = widthArray.map(width => `${this.placebo(url, width, 0)} ${width}w`);
    return str.join(', ');
  },

  // TODO: delete formateDuration if it's not used anymore
  formateDuration(seconds, format) {
    let data = new Date(seconds * 1000);

    if (format === 'default') {
      let h = data.getHours() > 0 ? data.getHours() + ' h ' : '';
      let min = data.getMinutes() > 0 ? data.getMinutes() + ' min ' : '';
      let s = data.getSeconds() > 0 ? data.getSeconds() + ' s ' : '';

      return h + min + s;
    } else {
      data = data.toISOString();
      if (this.durationSeconds < 3600) {
        return data.substr(14, 5);
      } else {
        return data.substr(11, 8);
      }
    }
  },
});
